"use strict";

var _interopRequireWildcard = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLoop = createLoop;
exports.enrollLoop = enrollLoop;
exports.getLoopById = getLoopById;
exports.getLoopList = getLoopList;
exports.getLoopStaff = getLoopStaff;
exports.getParticipant = getParticipant;
exports.loopNotifyLoopClientPOC = loopNotifyLoopClientPOC;
exports.unenrollParticipant = unenrollParticipant;
exports.updateLoopById = updateLoopById;
exports.updateLoopParticipantEnrolledBy = updateLoopParticipantEnrolledBy;
var _request = _interopRequireDefault(require("@/utils/request"));
var Constants = _interopRequireWildcard(require("@lifehikes/lh-js-common-lib"));
function getLoopList(token, query) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };

  // LHVO-5413 Pass source=adminPortal when calling Get Loop List API, so that it filters records by tenant
  query.source = Constants.SOURCE_ADMIN_PORTAL;
  return (0, _request.default)({
    url: '/loops',
    method: 'get',
    headers,
    params: query
  });
}
function getLoopById(token, id) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/loops/' + id,
    method: 'get',
    headers
  });
}
function createLoop(token, formData) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const data = formData;
  return (0, _request.default)({
    url: '/loops',
    method: 'post',
    headers,
    data
  });
}
function updateLoopById(token, id, formData) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  const data = formData;
  return (0, _request.default)({
    url: '/loops/' + id,
    method: 'put',
    headers,
    data
  });
}
function getParticipant(token, id) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/loops/' + id + '/participants',
    method: 'get',
    headers
  });
}
function unenrollParticipant(token, loopId, userUuid) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/loops/' + loopId + '/users/' + userUuid + '/unenroll',
    method: 'post',
    headers
  });
}
function getLoopStaff(token, id, query) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/loops/' + id + '/staff',
    method: 'get',
    headers,
    params: query
  });
}
function enrollLoop(token, data) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/user-loops/register-enroll',
    method: 'post',
    headers,
    data
  });
}
function loopNotifyLoopClientPOC(token, id, data) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/loops/' + id + '/staffs/notify',
    method: 'post',
    headers,
    data
  });
}
function updateLoopParticipantEnrolledBy(token, userId, loopId, data) {
  const headers = {
    'Authorization': 'Bearer ' + token
  };
  return (0, _request.default)({
    url: '/user-loops/users/' + userId + '/loops/' + loopId + '/enrolledBy',
    method: 'post',
    headers,
    data
  });
}